/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { lazy } from "react";
import { Loadable } from "components/Loadable";

const DataManager = Loadable(lazy(() => import("./index")));
const DataManagerList = Loadable(lazy(() => import("sections/models/content/list")));

const dataRoutes = [
    {
        path: "/data",
        element: <DataManager />,
    },
    {
        path: "/data/list",
        element: <DataManagerList />,
    },
];
export { dataRoutes };
